import '../../toolForm.css';
import { Input } from 'antd';
import React from 'react';

import { isInputPassword } from '../../../utils/misc';

import type { toolInput } from '../../../interfaces';
import type { FormInstance } from 'antd';

const StringInput: React.FC<{
  input: toolInput;
  form: FormInstance<any>;
  onValueChange?: (name: string) => void;
  onValueClear?: () => void;
}> = ({ input, form, onValueChange, onValueClear }) => {
  return isInputPassword(input) ? (
    <Input.Password
      name={input.name}
      value={form.getFieldValue(input.name)}
      placeholder={''}
      allowClear
      onClear={() => {
        form.setFieldValue(input.name, undefined);
        if (onValueClear) onValueClear();
      }}
      onChange={(e) => {
        form.setFieldValue(input.name, e.target.value);
        if (onValueChange) {
          onValueChange(input.name);
        }
      }}
      style={{
        maxWidth: '600px',
      }}
    />
  ) : (
    <Input
      name={input.name}
      value={form.getFieldValue(input.name)}
      placeholder={''}
      autoComplete="on"
      allowClear
      onClear={() => {
        form.setFieldValue(input.name, undefined);
        if (onValueClear) onValueClear();
      }}
      onChange={(e) => {
        form.setFieldValue(input.name, e.target.value);
        if (onValueChange) {
          onValueChange(input.name);
        }
      }}
      style={{
        maxWidth: '600px',
      }}
    />
  );
};

export { StringInput };
